export default {
    namespaced: true,
    state: {
        // 判断Ajax是否完成
        startPortAjaxComplete: false,// false-未完成、true-完成
        // 始发港数据
        startPort: []
    },
    mutations: {
        // 判断Ajax是否完成
        startPortAjaxComplete(state, value) {
            state.startPortAjaxComplete = value;
        },
        // 始发港数据
        startPort(state, value) {
            state.startPort = value;
        },
    }
};
